module.exports = __webpack_public_path__ + "img/bootstrap-5-1.6aae84ab.svg";